import React from 'react'
import { toTitleCase } from '@mobi/utils/string'
import type { Acceptor, BetSlipItem, Race, Selection } from '@mobi/betslip/types'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { spacing } from '@mobi/component-library/Foundations'
import { getIconTypeFromMeetingCode } from '@core/Areas/Quickbet/helpers/IconTypeHelper'
import { SelectionDisplay } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/BetInfoHeader/Components/Common/SelectionDisplay'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'

export const RacingHeader: React.FC<{
  races: Race[]
  acceptors: Acceptor[]
  selection: Selection
  betLegType: BetSlipItem['multiLegBetType']
}> = ({ races, acceptors, selection, betLegType }) => {
  const { raceNumber, meetingName } = races[0]

  const iconType = getIconTypeFromMeetingCode(races[0].meetingCode)
  return (
    <Flex flexDirection='column' gap={spacing.smx1}>
      <SecondaryInfo
        marketInfo={
          <>
            {iconType && <Icon size='1.6rem' type={iconType} />}
            <strong>R{raceNumber}</strong> {toTitleCase(meetingName)}
          </>
        }
      />

      <SelectionDisplay
        races={races}
        acceptors={acceptors}
        selection={selection}
        multiBetLegType={betLegType === 'W' ? 'Win' : 'Place'}
      />
    </Flex>
  )
}
